import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import NavBar from '../../../components/NavBar';
import AvcAcompanhamentoIcon from '../../../images/avc/acompanhamento-avc.svg';
import AvcIndicadoresAngelsIcon from '../../../images/avc/indicadores-angels.svg';

const avcPages = [
	{
		title: 'Acompanhamento AVC',
		link: '/avc/acompanhamento',
		icon: AvcAcompanhamentoIcon,
	},
	{
		title: 'Indicadores Angels',
		link: '/avc/indicadores-angels',
		icon: AvcIndicadoresAngelsIcon,
	},
];

const normalizeAccessValue = (value = '') =>
	String(value || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();

const canAccessAvcHub = (user = {}) => {
	const hubProfiles = ['subhue', 'desenvolvedor', 'smsrio', 'sms rio', 'sms'];
	const userProfiles = [
		user?.nome,
		user?.unidade,
		user?.cargo,
		...(Array.isArray(user?.permissao)
			? user.permissao
			: [user?.permissao].filter(Boolean)),
	].map(normalizeAccessValue);

	return userProfiles.some((profile) => hubProfiles.includes(profile));
};

function AvcHub() {
	let user = {};
	try {
		user = JSON.parse(Cookies.get('user') || '{}');
	} catch {
		user = {};
	}

	if (!canAccessAvcHub(user)) {
		return <Navigate to='/avc/acompanhamento' replace />;
	}

	return (
		<div className='flex min-h-screen flex-col bg-white font-inter'>
			<NavBar />

			<header className='mt-[80px] flex h-[110px] w-full items-center justify-center bg-[#F0F4F8] px-8 py-[36px] text-center'>
				<h1 className="font-['Roboto'] text-[28px] font-semibold leading-[38px] text-[#13335A]">
					Acompanhamento AVC
				</h1>
			</header>

			<main className='flex flex-1 justify-center bg-white'>
				<div className='flex min-h-[407px] w-full max-w-[1200px] flex-col items-center gap-6 px-8 pb-16 pt-8'>
					<div className='h-[2px] w-full shrink-0 bg-[#E3E3E3]' />

					<div className='grid grid-cols-1 justify-center gap-12 sm:grid-cols-2'>
					{avcPages.map(({ title, link, icon }) => (
						<Link
							key={link}
							to={link}
							className='flex h-[250px] w-[200px] flex-col items-center justify-center gap-[10px] rounded-[8px] bg-[#13335A] px-4 py-[10px] text-center no-underline shadow-[3px_3px_4px_rgba(0,0,0,0.30)] transition duration-300 hover:-translate-y-1 hover:bg-[#17416F]'>
							<div className='flex h-[140px] shrink-0 items-center justify-center gap-[10px] self-stretch'>
								<img
									src={icon}
									alt=''
									className='max-h-[83px] max-w-[80px]'
								/>
							</div>
							<div className='h-[3px] shrink-0 self-stretch bg-[#ECEDED]' />
							<h2 className="flex h-10 w-[165px] shrink-0 items-center justify-center overflow-hidden text-ellipsis whitespace-nowrap font-['Roboto'] text-[16px] font-medium leading-[19px] text-[#ECEDED]">
								{title}
							</h2>
						</Link>
					))}
				</div>
				</div>
			</main>
		</div>
	);
}

export default AvcHub;
